module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('vue-headful', {
    attrs: {
      "title": "SGP - Rating da Entidade"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Rating da Entidade:\n\n      "), (_vm.rating.classificacao) ? _c('span', [_vm._v(_vm._s(_vm.rating.classificacao.nota) + " ")]) : _vm._e(), _vm._v(" "), (_vm.calculando) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "font-size": "30px"
    }
  })]) : _c('span', [(!_vm.somenteLeitura && !_vm.temDataErrada) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarRating($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.imprimirRelatorio($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Imprimir")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closewindow($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Sair do relatório ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.tudoPreenchido > 0) ? _c('span', {
    staticClass: "alertaCamposPendentes"
  }, [_vm._v("Ainda falta preencher "), _c('b', [_vm._v(_vm._s(_vm.tudoPreenchido))]), _vm._v(" campos de Certidões ou Cadin")]) : _vm._e(), _vm._v(" "), (_vm.temDataErrada) ? _c('span', {
    staticClass: "alertaCamposPendentes"
  }, [(_vm.tudoPreenchido > 0) ? _c('br') : _vm._e(), _vm._v("Tem data errada! Favor verifique-as.")]) : _vm._e(), _vm._v(" "), (_vm.pendenciasCadastro.total > 0) ? _c('span', {
    staticClass: "alertaCamposPendentes atualizavel",
    on: {
      "click": function($event) {
        return _vm.$modal.show('avisoCadastro')
      }
    }
  }, [(_vm.tudoPreenchido > 0 || _vm.temDataErrada) ? _c('br') : _vm._e(), _c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da entidade incompleto: "), _c('b', [_vm._v(_vm._s(_vm.pendenciasCadastro.total))]), _vm._v(" " + _vm._s(_vm.pendenciasCadastro.total === 1 ? 'item' : 'itens') + ". Clique para ver.")]) : _vm._e()], 1)]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Validação',
        href: '/'
      }, {
        text: 'Propostas',
        href: '#'
      }, {
        text: 'Rating da Entidade',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "rating"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calculando),
      expression: "calculando"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table m0"
  }, [_c('tr', [_c('td', {
    staticClass: "etiquetas w10"
  }, [_vm._v("Convenente:")]), _vm._v(" "), _c('td', {
    staticClass: "valores",
    attrs: {
      "colspan": "7"
    }
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.dadosGerais.entidade.ds_nome))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Código:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.dadosGerais.entidade.nr_codigo_forn_erp))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.dadosGerais.entidade.ds_cnpj)))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Data de abertura:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dadosGerais.entidade.dt_data_expedicao_cnpj, "L")))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Tempo de abertura:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dadosGerais.entidade.dt_data_expedicao_cnpj, "from", "now")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "etiquetas"
  }, [_vm._v("Dirigentes:")]), _vm._v(" "), (_vm.rating.dirigentes) ? _c('table', {
    staticClass: "table table-bordered text-center nao_imprimir m0"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.rating.dirigentes), function(dirigente) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dirigente.ds_nome) + "    "), _c('span', {
      staticStyle: {
        "color": "cornflowerblue"
      }
    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dirigente.ds_cpf))]), _vm._v(" "), _c('td', [_c('money', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control text-right",
      attrs: {
        "onchange": _vm.totalSerasaDirigentes,
        "disabled": _vm.somenteLeitura,
        "name": "serasa_dirigente",
        "type": "text"
      },
      model: {
        value: (dirigente.serasa),
        callback: function($$v) {
          _vm.$set(dirigente, "serasa", $$v)
        },
        expression: "dirigente.serasa"
      }
    })], 1), _vm._v(" "), _c('td', [_c('money', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control text-right",
      attrs: {
        "onchange": _vm.totalSCPCDirigentes,
        "disabled": _vm.somenteLeitura,
        "name": "scpc_dirigente",
        "type": "text"
      },
      model: {
        value: (dirigente.scpc),
        callback: function($$v) {
          _vm.$set(dirigente, "scpc", $$v)
        },
        expression: "dirigente.scpc"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))]), _vm._v(" "), _c('td', [_c('i', {
      class: ['fa fa-circle ', dirigente.bt_ativo ? 'text-green' : 'text-red'],
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.rating.dirigentes) ? _c('table', {
    staticClass: "table table-bordered text-center imprimir"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.rating.dirigentes), function(dirigente) {
    return _c('tr', [_c('td', [_c('span', {
      staticClass: "fl"
    }, [_vm._v("\n                      " + _vm._s(dirigente.ds_nome) + "  \n                      "), _c('span', {
      staticStyle: {
        "color": "cornflowerblue"
      }
    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))])]), _vm._v(" "), _c('span', {
      staticClass: "fr"
    }, [_vm._v("CPF: " + _vm._s(dirigente.ds_cpf))])]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")) + " à " + _vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")) + "\n                  ")]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("real")(dirigente.serasa)))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("real")(dirigente.scpc)))])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.rating.consultas) ? _c('table', {
    staticClass: "tabela_consultas"
  }, [_vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w20"
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "serasa_entidade",
      "type": "text",
      "disabled": _vm.somenteLeitura
    },
    model: {
      value: (_vm.rating.consultas.serasa.entidade),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.serasa, "entidade", $$v)
      },
      expression: "rating.consultas.serasa.entidade"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td', {
    staticClass: "valores w30"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        placement: 'left'
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
    }],
    staticClass: "data w40",
    attrs: {
      "title": '<h5>Informe a Data da Consulta do Cepim</h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.dataCepim),
      expression: "rating.consultas.certidoes.dataCepim"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast'),
      expression: "'required|validdate|dateeqpast'"
    }],
    ref: "Cepim",
    staticClass: "form-control",
    attrs: {
      "id": "Cepim",
      "type": "text",
      "name": "Cepim",
      "disabled": _vm.somenteLeitura,
      "data-vv-as": "Cepim",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.certidoes.dataCepim)
    },
    on: {
      "blur": _vm.verificaData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.certidoes, "dataCepim", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Cepim')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cepim')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "textoLigacao w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "listaSituacao w50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.Cepim),
      expression: "rating.consultas.certidoes.Cepim"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.somenteLeitura
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rating.consultas.certidoes, "Cepim", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcularRating]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Com Restrição")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Nada Consta")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('money', {
    staticClass: "form-control text-right",
    attrs: {
      "disabled": true,
      "name": "serasa_dirigentes",
      "type": "text"
    },
    model: {
      value: (_vm.rating.consultas.serasa.dirigentes),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.serasa, "dirigentes", $$v)
      },
      expression: "rating.consultas.serasa.dirigentes"
    }
  })], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        placement: 'left'
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
    }],
    staticClass: "data w40",
    attrs: {
      "title": '<h5>Informe a Data de Validade da PGFN</h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.dataCND),
      expression: "rating.consultas.certidoes.dataCND"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate'),
      expression: "'required|validdate'"
    }],
    ref: "CND",
    staticClass: "form-control",
    attrs: {
      "id": "CND",
      "type": "text",
      "name": "CND",
      "disabled": _vm.somenteLeitura,
      "data-vv-as": "CND",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.certidoes.dataCND)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.certidoes, "dataCND", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('CND')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CND')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "textoLigacao w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "listaSituacao w50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.CND),
      expression: "rating.consultas.certidoes.CND"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.somenteLeitura
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rating.consultas.certidoes, "CND", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcularRating]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Vencida")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Vigente")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "serasa_coobrigacao",
      "type": "text",
      "disabled": _vm.somenteLeitura
    },
    model: {
      value: (_vm.rating.consultas.serasa.coobrigacao),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.serasa, "coobrigacao", $$v)
      },
      expression: "rating.consultas.serasa.coobrigacao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SERASA de dirigentes coobrigação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SERASA de dirigentes coobrigação')))]) : _vm._e()]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        placement: 'left'
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
    }],
    staticClass: "data w40",
    attrs: {
      "title": '<h5>Informe a data de Validade da CRF</h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.dataCRF),
      expression: "rating.consultas.certidoes.dataCRF"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate'),
      expression: "'required|validdate'"
    }],
    ref: "CRF",
    staticClass: "form-control",
    attrs: {
      "id": "CRF",
      "type": "text",
      "name": "CRF",
      "disabled": _vm.somenteLeitura,
      "data-vv-as": "CRF",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.certidoes.dataCRF)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.certidoes, "dataCRF", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('CRF')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CRF')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "textoLigacao w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "listaSituacao w50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.CRF),
      expression: "rating.consultas.certidoes.CRF"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.somenteLeitura
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rating.consultas.certidoes, "CRF", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcularRating]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Vencida")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Vigente")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        placement: 'left'
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
    }],
    staticClass: "data w40",
    attrs: {
      "title": '<h5>Informe a data de Validade da CNDT</h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.dataCNDT),
      expression: "rating.consultas.certidoes.dataCNDT"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate'),
      expression: "'required|validdate'"
    }],
    ref: "CNDT",
    staticClass: "form-control",
    attrs: {
      "id": "CNDT",
      "type": "text",
      "name": "CNDT",
      "disabled": _vm.somenteLeitura,
      "data-vv-as": "CNDT",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.certidoes.dataCNDT)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.certidoes, "dataCNDT", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('CNDT')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNDT')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "textoLigacao w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "listaSituacao w50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.CNDT),
      expression: "rating.consultas.certidoes.CNDT"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.somenteLeitura
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rating.consultas.certidoes, "CNDT", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcularRating]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Vencida")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Vigente")])])])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "scpc_entidade",
      "type": "text",
      "disabled": _vm.somenteLeitura
    },
    model: {
      value: (_vm.rating.consultas.scpc.entidade),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.scpc, "entidade", $$v)
      },
      expression: "rating.consultas.scpc.entidade"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SCPC da entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC da entidade')))]) : _vm._e()]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        placement: 'left'
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
    }],
    staticClass: "data w40",
    attrs: {
      "title": '<h5>Informe a Data da Consulta do CADIN da Entidade</h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.cadin.dataEntidade),
      expression: "rating.consultas.cadin.dataEntidade"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast'),
      expression: "'required|validdate|dateeqpast'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cadin_entidade",
      "type": "text",
      "name": "cadin_entidade",
      "disabled": _vm.somenteLeitura,
      "data-vv-as": "cadin_entidade",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.cadin.dataEntidade)
    },
    on: {
      "blur": _vm.verificaData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.cadin, "dataEntidade", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cadin_entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin_entidade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "textoLigacao w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "listaSituacao w50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.cadin.entidade),
      expression: "rating.consultas.cadin.entidade"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.somenteLeitura
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rating.consultas.cadin, "entidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcularRating]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Com Restrição")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Nada Consta")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "disabled": true,
      "name": "scpc_dirigentes",
      "type": "text"
    },
    model: {
      value: (_vm.rating.consultas.scpc.dirigentes),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.scpc, "dirigentes", $$v)
      },
      expression: "rating.consultas.scpc.dirigentes"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SCPC de dirigentes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC de dirigentes')))]) : _vm._e()]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        placement: 'left'
      }),
      expression: "{inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', placement: 'left'}"
    }],
    staticClass: "data w40",
    attrs: {
      "title": '<h5>Informe a data da Consulta do CADIN dos Dirigentes</h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.cadin.dataDirigentes),
      expression: "rating.consultas.cadin.dataDirigentes"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast'),
      expression: "'required|validdate|dateeqpast'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cadin_dirigentes",
      "type": "text",
      "name": "cadin_dirigentes",
      "disabled": _vm.somenteLeitura,
      "data-vv-as": "cadin_dirigentes",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.cadin.dataDirigentes)
    },
    on: {
      "blur": _vm.verificaData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.cadin, "dataDirigentes", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cadin_dirigentes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin_dirigentes')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "textoLigacao w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "listaSituacao w50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.cadin.dirigentes),
      expression: "rating.consultas.cadin.dirigentes"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.somenteLeitura
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rating.consultas.cadin, "dirigentes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcularRating]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Com Restrição")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Nada Consta")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "scpc_coobrigacao",
      "type": "text",
      "disabled": _vm.somenteLeitura
    },
    model: {
      value: (_vm.rating.consultas.scpc.coobrigacao),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.scpc, "coobrigacao", $$v)
      },
      expression: "rating.consultas.scpc.coobrigacao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SCPC de dirigentes coobrigação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC de dirigentes coobrigação')))]) : _vm._e()]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('td', {
    staticClass: "valores"
  }, [(_vm.rating.consultas.cadin.dataCoobrigacao !== 0) ? _c('div', {
    staticClass: "data w40"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.cadin.dataCoobrigacao),
      expression: "rating.consultas.cadin.dataCoobrigacao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqpast'),
      expression: "'required|validdate|dateeqpast'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cadin_dirigentes_coobrigacao",
      "type": "text",
      "name": "cadin_dirigentes_coobrigacao",
      "disabled": _vm.somenteLeitura,
      "data-vv-as": "cadin_dirigentes_coobrigacao",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.cadin.dataCoobrigacao)
    },
    on: {
      "blur": _vm.verificaData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.cadin, "dataCoobrigacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cadin_dirigentes_coobrigacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin_dirigentes_coobrigacao')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "textoLigacao w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "listaSituacao w50"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.cadin.coobrigacao),
      expression: "rating.consultas.cadin.coobrigacao"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.somenteLeitura
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rating.consultas.cadin, "coobrigacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcularRating]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Com Restrição")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Nada Consta")])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.rating.consultas) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "tabela_consultas"
  }, [_c('tr', [_c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Total Geral:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w20"
  }, [_c('money', {
    staticClass: "form-control text-right",
    attrs: {
      "name": "total_scpc_serasa",
      "type": "text",
      "disabled": true
    },
    model: {
      value: (_vm.rating.consultas.totalGeral),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas, "totalGeral", $$v)
      },
      expression: "rating.consultas.totalGeral"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w50"
  }, [_vm._v("Quantidade de Pessoas Politicamente Expostas (PEP):")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.PEP),
      expression: "rating.consultas.PEP"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "pep",
      "type": "text",
      "name": "pep",
      "disabled": _vm.somenteLeitura
    },
    domProps: {
      "value": (_vm.rating.consultas.PEP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas, "PEP", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "tabela_consultas"
  }, [_c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Investimento Social (ISD, últimos 3 anos):")]), _vm._v(" "), _c('td', {
    staticClass: "valores w20"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado",
    attrs: {
      "title": '<h5>Refere-se a soma dos valores contratados e suplementados no projeto</h5>'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._f("real")(_vm.rating.experiencia.investimentoAte3Anos)) + "\n                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "valores w20"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Participantes Diretos (ISD, últimos 3 anos):")]), _vm._v(" "), _c('td', {
    staticClass: "valores w20"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado",
    attrs: {
      "title": '<h5>Refere-se a quantidade total de participantes dos projetos contratados</h5>'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.rating.experiencia.participantesAte3Anos) + "\n                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "valores w20"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Nº Projetos com a FBB:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w20"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado",
    attrs: {
      "title": '<h5>Refere-se a quantidade total de participantes dos projetos contratados</h5>'
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.rating.experiencia.qtdeProjeto) + "\n                    ")])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "valores w20"
  }, [_vm._v(" ")])])])]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "tabela_consultas"
  }, [_c('tr', [_c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "cabecalho",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('td', {
    staticClass: "cabecalho",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Projetos em Execução, ETO, SPS:")]), _vm._v(" "), _c('td', {
    staticClass: "cabecalho",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Projetos Encerrados (3 anos):")])]), _vm._v(" "), _c('tr', [_c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "etiquetas w20"
  }, [_vm._v("Ocorr. Peso 2:")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "valores w10"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo2)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": _vm.entidadeOcorrenciaTipo2
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo2.length))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Qtd Executando:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.qtde))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Qtd Executado:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.qtde))])])]), _vm._v(" "), _c('tr', [_c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "etiquetas w20"
  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "valores w10"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo3)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": _vm.entidadeOcorrenciaTipo3
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo3.length))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Ocorr. Peso 2:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo2)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": _vm.projetosExecutandoOcorrenciaTipo2
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo2.length))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosEncerrados.tipo3)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": _vm.projetosEncerradosOcorrenciaTipo3
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.tipo3.length))])])]), _vm._v(" "), _c('tr', [_c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "etiquetas w20"
  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "valores w10"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo4)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": _vm.entidadeOcorrenciaTipo4
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo4.length))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo3)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": _vm.projetosExecutandoOcorrenciaTipo3
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo3.length))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosEncerrados.tipo4)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": _vm.projetosEncerradosOcorrenciaTipo4
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.tipo4.length))])])]), _vm._v(" "), _c('tr', [_c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "etiquetas w20"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "valores w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo4)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": _vm.projetosExecutandoOcorrenciaTipo4
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo4.length))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Qtd Peso 3:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.qtdeTipo3))])])]), _vm._v(" "), _c('tr', [_c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "etiquetas w20"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "valores w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("Qtd Peso 3:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.qtdeTipo3))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("% com Peso 3:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.rating.ocorrencias.projetosEncerrados.percTipo3)))])])]), _vm._v(" "), _c('tr', [_c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "etiquetas w20"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "valores w10"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v("% com Peso 3:")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.rating.ocorrencias.projetosExecutando.percTipo3)))])]), _vm._v(" "), _c('td', {
    staticClass: "etiquetas w20"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "valores w10 w10"
  }, [_vm._v(" ")])])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', [_c('table', {
    staticClass: "table table-condensed ratingCalculos"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Representa a situação da entidade e de seus dirigentes com relação a prestação de contas e ao cumprimento de seus compromisssos</h5>'
    }
  }, [_vm._v("CD")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Reflete de maneira indireta as condições economico-financeiras da entidade</h5>'
    }
  }, [_vm._v("RFP")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Sinaliza a capacidade de articulação da entidade considerando que quanto maior o investimento da FBB maior interesse , disposição e compentência em apresentar propostas</h5>'
    }
  }, [_vm._v("IS")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Evidencia o aspecto social da atuação da entidade por meio da quantidade de participantes diretos atendidos</h5>'
    }
  }, [_vm._v("PD")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Reflete a experiência da entidade com base em seu tempo de constituição</h5>'
    }
  }, [_vm._v("HIS 1")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Experiência em projetos e o modus operandi da Fundação</h5>'
    }
  }, [_vm._v("HIS 2")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Ocorrências registradas para projetos em execução</h5>'
    }
  }, [_vm._v("OC 1")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Ocorrências registradas para projetos encerrado</h5>'
    }
  }, [_vm._v("OC 2")])])]), _vm._v(" "), _c('tr', {
    staticClass: "dado"
  }, [_c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.CD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.RFP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.IS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.PD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC3))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_c('span', {
    staticClass: "formula"
  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.formula) + " = ")]), _c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.total))])])])])]), _vm._v(" "), _c('td', {
    staticClass: "ratingNota"
  }, [_vm._v("Rating Entidade"), _c('br'), _c('span', {
    class: 'dado rating' + _vm.rating.classificacao.nota
  }, [_vm._v(_vm._s(_vm.rating.classificacao.nota))])])])])])])])]), _vm._v(" "), _c('modal', {
    staticClass: "topo modal-wrapper nao_imprimir",
    attrs: {
      "name": "avisoCadastro",
      "width": "60%",
      "height": "auto",
      "scrollable": true
    }
  }, [_c('div', {
    staticClass: "box-header with-border cabecalhoAviso"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da entidade incompleto\n          ")]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('b-button', {
    staticClass: "btn btn-warning btn-sm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('avisoCadastro')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Fechar")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "avisoCadastro"
    }
  }, [_c('p', [_vm._v("\n            O rating foi calculado com as informações disponíveis. Os itens abaixo estão\n            faltando no cadastro da entidade e devem ser completados para que a nota seja confiável.\n          ")]), _vm._v(" "), (_vm.pendenciasCadastro.obrigatorias.length > 0) ? _c('div', [_c('div', {
    staticClass: "secao"
  }, [_vm._v("Obrigatórios — afetam a nota:")]), _vm._v(" "), _c('ul', {
    staticClass: "listaPendencias"
  }, _vm._l((_vm.pendenciasCadastro.obrigatorias), function(pendencia) {
    return _c('li', [_c('b', [_vm._v(_vm._s(pendencia.titulo))]), _vm._v(" — " + _vm._s(pendencia.efeito) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.pendenciasCadastro.opcionais.length > 0) ? _c('div', [_c('div', {
    staticClass: "secao"
  }, [_vm._v("Não obrigatórios — não alteram a nota:")]), _vm._v(" "), _c('ul', {
    staticClass: "listaPendencias"
  }, _vm._l((_vm.pendenciasCadastro.opcionais), function(pendencia) {
    return _c('li', [_c('b', [_vm._v(_vm._s(pendencia.titulo))]), _vm._v(" — " + _vm._s(pendencia.efeito) + "\n              ")])
  }), 0)]) : _vm._e()])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imprimir"
  }, [_c('img', {
    staticClass: "logo_relatorio",
    attrs: {
      "src": "/static/img/logo-login.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tituloRating"
  }, [_vm._v("Rating da Entidade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "secao"
  }, [_vm._v("Dados da entidade:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "requerido",
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("SERASA")]), _vm._v(" "), _c('th', {
    staticClass: "requerido",
    staticStyle: {
      "width": "14%"
    }
  }, [_vm._v("SCPC")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Início do Mandato")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Vigência do Mandato")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("Ativo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "w50 p0"
  }, [_vm._v("Dirigente")]), _vm._v(" "), _c('th', {
    staticClass: "w20 p0"
  }, [_vm._v("Mandato")]), _vm._v(" "), _c('th', {
    staticClass: "w10 p0"
  }, [_vm._v("SERASA")]), _vm._v(" "), _c('th', {
    staticClass: "w10 p0"
  }, [_vm._v("SCPC")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "secao"
  }, [_vm._v("Consultas cadastrais e regularidade fiscal e previdenciária:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "cabecalho b",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("SERASA:")]), _vm._v(" "), _c('td', {
    staticClass: "cabecalho b",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("CEPIM e Certidões:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "etiquetas w30"
  }, [_vm._v("Cepim"), _c('span', {
    staticClass: "dataConsulta"
  }), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("PGFN"), _c('span', {
    staticClass: "dataValidade"
  }), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("CRF"), _c('span', {
    staticClass: "dataValidade"
  }), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("CNDT"), _c('span', {
    staticClass: "dataValidade"
  }), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "cabecalho b",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("SCPC:")]), _vm._v(" "), _c('td', {
    staticClass: "cabecalho b",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("CADIN:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Entidade"), _c('span', {
    staticClass: "dataConsulta"
  }), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Dirigentes"), _c('span', {
    staticClass: "dataConsulta"
  }), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "etiquetas"
  }, [_vm._v("Dirigentes Coobrigação"), _c('span', {
    staticClass: "dataConsulta"
  }), _vm._v(":")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "secao"
  }, [_vm._v("Experiência com a FBB:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "secao"
  }, [_vm._v("Ocorrências:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "secao"
  }, [_vm._v("Rating:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77a10266!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/relatorioRating.vue
// module id = 2020
// module chunks = 1